// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form_EEbew {
  width: 100%;
  min-width: 400px;
  max-width: 100vw;
  max-height: 60vh;
  padding: 16px;
}

.fixed_AksbY {
  width : 100%;
  position : relative;
  height : 100%;
}

.fullWidth_f5A_L {
  width : 100%;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/api-ui-fota-management/lib/views/itemEditor/FotaItemEditor.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,YAAY;AACd","sourcesContent":[".form {\n  width: 100%;\n  min-width: 400px;\n  max-width: 100vw;\n  max-height: 60vh;\n  padding: 16px;\n}\n\n.fixed {\n  width : 100%;\n  position : relative;\n  height : 100%;\n}\n\n.fullWidth {\n  width : 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": `form_EEbew`,
	"fixed": `fixed_AksbY`,
	"fullWidth": `fullWidth_f5A_L`
};
export default ___CSS_LOADER_EXPORT___;
